import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MatSlideToggleChange, MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { TranslocoService, TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { UserService } from '../../../modules/security/services/user.service';
import { User } from '../../../modules/security/models/user.model';
import { AuthenticationService } from '../../auth/authentication.service';
import { UsersService } from '../../users/users.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'nuvolaweb-create-update-user',
  templateUrl: './create-update-user.component.html',
  styleUrls: ['./create-update-user.component.scss'],
  providers: [
    {
      provide: TRANSLOCO_SCOPE, useValue: { scope: 'users' }
    }
  ],
})
export class CreateUpdateUserComponent implements OnInit {
  @ViewChild('deleteRowConfirmation', { static: true }) resetPasswordModal: MatDialogRef<any>;
  @ViewChild('sendActiveEmail', { static: true }) sendEmailModal: MatDialogRef<any>;

  // tslint:disable-next-line:no-input-rename
  @Input('selectedRow') selectedRow: User;
  @Output() createUpdate: EventEmitter<any> = new EventEmitter();
  @Input() isDoctorCreating: boolean;
  @Input() isDoctorToApprove: boolean;
  @Input() isMyProfileClick: boolean;
  private profileComplete = true;
  public userForm: FormGroup;
  public isEditLoading = false;
  public roles: { id: string, value: string }[];
  public areas: { id: string, value: string }[];
  public superAgents: User[];
  public agents: User[];
  public distributors: User[];
  public hide = true;
  public addresses: any[] = [];
  users: User[];
  groups: any[];
  executives: User[];
  public showActiveDoctorButton = false;
  public showHowManyPatients = false;
  public currentUser: User;
  public storageBaseUrl: string = environment.storageBaseUrl;
  public currentLanguage: string;
  public currentLoggedInUser: User;
  public policyConfirmedDate: Date;
  public whatsappPhoneNumber = '';

  // tslint:disable-next-line:max-line-length
  allCountriesArray = [['Afghanistan (‫افغانستان‬‎)', 'af', '93'], ['Albania (Shqipëri)', 'al', '355'], ['Algeria (‫الجزائر‬‎)', 'dz', '213'], ['American Samoa', 'as', '1684'], ['Andorra', 'ad', '376'], ['Angola', 'ao', '244'], ['Anguilla', 'ai', '1264'], ['Antigua and Barbuda', 'ag', '1268'], ['Argentina', 'ar', '54'], ['Armenia (Հայաստան)', 'am', '374'], ['Aruba', 'aw', '297'], ['Australia', 'au', '61', 0], ['Austria (Österreich)', 'at', '43'], ['Azerbaijan (Azərbaycan)', 'az', '994'], ['Bahamas', 'bs', '1242'], ['Bahrain (‫البحرين‬‎)', 'bh', '973'], ['Bangladesh (বাংলাদেশ)', 'bd', '880'], ['Barbados', 'bb', '1246'], ['Belarus (Беларусь)', 'by', '375'], ['Belgium (België)', 'be', '32'], ['Belize', 'bz', '501'], ['Benin (Bénin)', 'bj', '229'], ['Bermuda', 'bm', '1441'], ['Bhutan (འབྲུག)', 'bt', '975'], ['Bolivia', 'bo', '591'], ['Bosnia and Herzegovina (Босна и Херцеговина)', 'ba', '387'], ['Botswana', 'bw', '267'], ['Brazil (Brasil)', 'br', '55'], ['British Indian Ocean Territory', 'io', '246'], ['British Virgin Islands', 'vg', '1284'], ['Brunei', 'bn', '673'], ['Bulgaria (България)', 'bg', '359'], ['Burkina Faso', 'bf', '226'], ['Burundi (Uburundi)', 'bi', '257'], ['Cambodia (កម្ពុជា)', 'kh', '855'], ['Cameroon (Cameroun)', 'cm', '237'], ['Canada', 'ca', '1', 1, ['204', '226', '236', '249', '250', '289', '306', '343', '365', '387', '403', '416', '418', '431', '437', '438', '450', '506', '514', '519', '548', '579', '581', '587', '604', '613', '639', '647', '672', '705', '709', '742', '778', '780', '782', '807', '819', '825', '867', '873', '902', '905']], ['Cape Verde (Kabu Verdi)', 'cv', '238'], ['Caribbean Netherlands', 'bq', '599', 1], ['Cayman Islands', 'ky', '1345'], ['Central African Republic (République centrafricaine)', 'cf', '236'], ['Chad (Tchad)', 'td', '235'], ['Chile', 'cl', '56'], ['China (中国)', 'cn', '86'], ['Christmas Island', 'cx', '61', 2], ['Cocos (Keeling) Islands', 'cc', '61', 1], ['Colombia', 'co', '57'], ['Comoros (‫جزر القمر‬‎)', 'km', '269'], ['Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)', 'cd', '243'], ['Congo (Republic) (Congo-Brazzaville)', 'cg', '242'], ['Cook Islands', 'ck', '682'], ['Costa Rica', 'cr', '506'], ['Côte d’Ivoire', 'ci', '225'], ['Croatia (Hrvatska)', 'hr', '385'], ['Cuba', 'cu', '53'], ['Curaçao', 'cw', '599', 0], ['Cyprus (Κύπρος)', 'cy', '357'], ['Czech Republic (Česká republika)', 'cz', '420'], ['Denmark (Danmark)', 'dk', '45'], ['Djibouti', 'dj', '253'], ['Dominica', 'dm', '1767'], ['Dominican Republic (República Dominicana)', 'do', '1', 2, ['809', '829', '849']], ['Ecuador', 'ec', '593'], ['Egypt (‫مصر‬‎)', 'eg', '20'], ['El Salvador', 'sv', '503'], ['Equatorial Guinea (Guinea Ecuatorial)', 'gq', '240'], ['Eritrea', 'er', '291'], ['Estonia (Eesti)', 'ee', '372'], ['Ethiopia', 'et', '251'], ['Falkland Islands (Islas Malvinas)', 'fk', '500'], ['Faroe Islands (Føroyar)', 'fo', '298'], ['Fiji', 'fj', '679'], ['Finland (Suomi)', 'fi', '358', 0], ['France', 'fr', '33'], ['French Guiana (Guyane française)', 'gf', '594'], ['French Polynesia (Polynésie française)', 'pf', '689'], ['Gabon', 'ga', '241'], ['Gambia', 'gm', '220'], ['Georgia (საქართველო)', 'ge', '995'], ['Germany (Deutschland)', 'de', '49'], ['Ghana (Gaana)', 'gh', '233'], ['Gibraltar', 'gi', '350'], ['Greece (Ελλάδα)', 'gr', '30'], ['Greenland (Kalaallit Nunaat)', 'gl', '299'], ['Grenada', 'gd', '1473'], ['Guadeloupe', 'gp', '590', 0], ['Guam', 'gu', '1671'], ['Guatemala', 'gt', '502'], ['Guernsey', 'gg', '44', 1], ['Guinea (Guinée)', 'gn', '224'], ['Guinea-Bissau (Guiné Bissau)', 'gw', '245'], ['Guyana', 'gy', '592'], ['Haiti', 'ht', '509'], ['Honduras', 'hn', '504'], ['Hong Kong (香港)', 'hk', '852'], ['Hungary (Magyarország)', 'hu', '36'], ['Iceland (Ísland)', 'is', '354'], ['India (भारत)', 'in', '91'], ['Indonesia', 'id', '62'], ['Iran (‫ایران‬‎)', 'ir', '98'], ['Iraq (‫العراق‬‎)', 'iq', '964'], ['Ireland', 'ie', '353'], ['Isle of Man', 'im', '44', 2], ['Israel (‫ישראל‬‎)', 'il', '972'], ['Italy (Italia)', 'it', '39', 0], ['Jamaica', 'jm', '1', 4, ['876', '658']], ['Japan (日本)', 'jp', '81'], ['Jersey', 'je', '44', 3], ['Jordan (‫الأردن‬‎)', 'jo', '962'], ['Kazakhstan (Казахстан)', 'kz', '7', 1], ['Kenya', 'ke', '254'], ['Kiribati', 'ki', '686'], ['Kosovo', 'xk', '383'], ['Kuwait (‫الكويت‬‎)', 'kw', '965'], ['Kyrgyzstan (Кыргызстан)', 'kg', '996'], ['Laos (ລາວ)', 'la', '856'], ['Latvia (Latvija)', 'lv', '371'], ['Lebanon (‫لبنان‬‎)', 'lb', '961'], ['Lesotho', 'ls', '266'], ['Liberia', 'lr', '231'], ['Libya (‫ليبيا‬‎)', 'ly', '218'], ['Liechtenstein', 'li', '423'], ['Lithuania (Lietuva)', 'lt', '370'], ['Luxembourg', 'lu', '352'], ['Macau (澳門)', 'mo', '853'], ['Macedonia (FYROM) (Македонија)', 'mk', '389'], ['Madagascar (Madagasikara)', 'mg', '261'], ['Malawi', 'mw', '265'], ['Malaysia', 'my', '60'], ['Maldives', 'mv', '960'], ['Mali', 'ml', '223'], ['Malta', 'mt', '356'], ['Marshall Islands', 'mh', '692'], ['Martinique', 'mq', '596'], ['Mauritania (‫موريتانيا‬‎)', 'mr', '222'], ['Mauritius (Moris)', 'mu', '230'], ['Mayotte', 'yt', '262', 1], ['Mexico (México)', 'mx', '52'], ['Micronesia', 'fm', '691'], ['Moldova (Republica Moldova)', 'md', '373'], ['Monaco', 'mc', '377'], ['Mongolia (Монгол)', 'mn', '976'], ['Montenegro (Crna Gora)', 'me', '382'], ['Montserrat', 'ms', '1664'], ['Morocco (‫المغرب‬‎)', 'ma', '212', 0], ['Mozambique (Moçambique)', 'mz', '258'], ['Myanmar (Burma) (မြန်မာ)', 'mm', '95'], ['Namibia (Namibië)', 'na', '264'], ['Nauru', 'nr', '674'], ['Nepal (नेपाल)', 'np', '977'], ['Netherlands (Nederland)', 'nl', '31'], ['New Caledonia (Nouvelle-Calédonie)', 'nc', '687'], ['New Zealand', 'nz', '64'], ['Nicaragua', 'ni', '505'], ['Niger (Nijar)', 'ne', '227'], ['Nigeria', 'ng', '234'], ['Niue', 'nu', '683'], ['Norfolk Island', 'nf', '672'], ['North Korea (조선 민주주의 인민 공화국)', 'kp', '850'], ['Northern Mariana Islands', 'mp', '1670'], ['Norway (Norge)', 'no', '47', 0], ['Oman (‫عُمان‬‎)', 'om', '968'], ['Pakistan (‫پاکستان‬‎)', 'pk', '92'], ['Palau', 'pw', '680'], ['Palestine (‫فلسطين‬‎)', 'ps', '970'], ['Panama (Panamá)', 'pa', '507'], ['Papua New Guinea', 'pg', '675'], ['Paraguay', 'py', '595'], ['Peru (Perú)', 'pe', '51'], ['Philippines', 'ph', '63'], ['Poland (Polska)', 'pl', '48'], ['Portugal', 'pt', '351'], ['Puerto Rico', 'pr', '1', 3, ['787', '939']], ['Qatar (‫قطر‬‎)', 'qa', '974'], ['Réunion (La Réunion)', 're', '262', 0], ['Romania (România)', 'ro', '40'], ['Russia (Россия)', 'ru', '7', 0], ['Rwanda', 'rw', '250'], ['Saint Barthélemy', 'bl', '590', 1], ['Saint Helena', 'sh', '290'], ['Saint Kitts and Nevis', 'kn', '1869'], ['Saint Lucia', 'lc', '1758'], ['Saint Martin (Saint-Martin (partie française))', 'mf', '590', 2], ['Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)', 'pm', '508'], ['Saint Vincent and the Grenadines', 'vc', '1784'], ['Samoa', 'ws', '685'], ['San Marino', 'sm', '378'], ['São Tomé and Príncipe (São Tomé e Príncipe)', 'st', '239'], ['Saudi Arabia (‫المملكة العربية السعودية‬‎)', 'sa', '966'], ['Senegal (Sénégal)', 'sn', '221'], ['Serbia (Србија)', 'rs', '381'], ['Seychelles', 'sc', '248'], ['Sierra Leone', 'sl', '232'], ['Singapore', 'sg', '65'], ['Sint Maarten', 'sx', '1721'], ['Slovakia (Slovensko)', 'sk', '421'], ['Slovenia (Slovenija)', 'si', '386'], ['Solomon Islands', 'sb', '677'], ['Somalia (Soomaaliya)', 'so', '252'], ['South Africa', 'za', '27'], ['South Korea (대한민국)', 'kr', '82'], ['South Sudan (‫جنوب السودان‬‎)', 'ss', '211'], ['Spain (España)', 'es', '34'], ['Sri Lanka (ශ්‍රී ලංකාව)', 'lk', '94'], ['Sudan (‫السودان‬‎)', 'sd', '249'], ['Suriname', 'sr', '597'], ['Svalbard and Jan Mayen', 'sj', '47', 1], ['Swaziland', 'sz', '268'], ['Sweden (Sverige)', 'se', '46'], ['Switzerland (Schweiz)', 'ch', '41'], ['Syria (‫سوريا‬‎)', 'sy', '963'], ['Taiwan (台灣)', 'tw', '886'], ['Tajikistan', 'tj', '992'], ['Tanzania', 'tz', '255'], ['Thailand (ไทย)', 'th', '66'], ['Timor-Leste', 'tl', '670'], ['Togo', 'tg', '228'], ['Tokelau', 'tk', '690'], ['Tonga', 'to', '676'], ['Trinidad and Tobago', 'tt', '1868'], ['Tunisia (‫تونس‬‎)', 'tn', '216'], ['Turkey (Türkiye)', 'tr', '90'], ['Turkmenistan', 'tm', '993'], ['Turks and Caicos Islands', 'tc', '1649'], ['Tuvalu', 'tv', '688'], ['U.S. Virgin Islands', 'vi', '1340'], ['Uganda', 'ug', '256'], ['Ukraine (Україна)', 'ua', '380'], ['United Arab Emirates (‫الإمارات العربية المتحدة‬‎)', 'ae', '971'], ['United Kingdom', 'gb', '44', 0], ['United States', 'us', '1', 0], ['Uruguay', 'uy', '598'], ['Uzbekistan (Oʻzbekiston)', 'uz', '998'], ['Vanuatu', 'vu', '678'], ['Vatican City (Città del Vaticano)', 'va', '39', 1], ['Venezuela', 've', '58'], ['Vietnam (Việt Nam)', 'vn', '84'], ['Wallis and Futuna (Wallis-et-Futuna)', 'wf', '681'], ['Western Sahara (‫الصحراء الغربية‬‎)', 'eh', '212', 1], ['Yemen (‫اليمن‬‎)', 'ye', '967'], ['Zambia', 'zm', '260'], ['Zimbabwe', 'zw', '263'], ['Åland Islands', 'ax', '358', 1]];
  allCountries = [];

  public currentLoggedUser;
  isUsaVersion: boolean;

  constructor(
    private _usersService: UsersService,
    private _userService: UserService,
    private _translocoService: TranslocoService,
    private _fb: FormBuilder,
    private snackBar: MatSnackBar,
    private modalServide: MatDialog,
    private _authService: AuthenticationService,
    private cd: ChangeDetectorRef,
    private location: Location,
    private router: Router
  ) {
    this.isUsaVersion = environment.isUsaVersion;
   }

  async ngOnInit() {
    // console.log('this.selectedRow', this.selectedRow);

    for (let i = 0; i < this.allCountriesArray.length; i++) {
      const c = this.allCountriesArray[i];
      this.allCountries.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }

    this.currentLanguage = this._translocoService.getActiveLang().toUpperCase();

    this.currentLoggedInUser = this._userService.readUserFromLocalStorage();
    const currentUserTemp = this._userService.readUserFromLocalStorage();
    this.showActiveDoctorButton = this.selectedRow !== undefined && this.selectedRow.needToBeApproved &&
      (currentUserTemp.role === 'AD' || currentUserTemp.role === 'EX' ||
        (currentUserTemp.role === 'US' && currentUserTemp.userGroup === 'AD'));

    this.formInit(this.selectedRow);

    // set the profilComplete based on current record
    if (this.selectedRow === undefined) {
      this.profileComplete = true;
    } else {
      this.profileComplete = this.selectedRow.profileComplete;
    }

    this.roles = [
      {
        id: 'AD',
        value: 'Super User'
      },
      {
        id: 'EX',
        value: 'Executive'
      },
      {
        id: 'SA',
        value: 'Super Agent'
      },
      {
        id: 'DI',
        value: 'Distributor'
      },
      {
        id: 'AG',
        value: 'Agent'
      },
      {
        id: 'DO',
        value: 'Doctor'
      },
      {
        id: 'US',
        value: 'User'
      }
    ];

    this.currentLoggedUser = await this._userService.readUserFromLocalStorage();
    // if (currentLoggedUser.role == "EX") {
    //   this.roles = this.roles.filter(c => c.id != 'AD');
    // }
    if (!this.isMyProfileClick) {
      if ((this.currentLoggedUser.role === 'EX' && this.currentLoggedUser.executiveArea === 'A') ||
        (this.currentLoggedUser.role === 'US' && this.currentLoggedUser.userGroup === 'AD')) {
        this.roles = [
          {
            id: 'DO',
            value: 'Doctor'
          }
        ];
        this.userForm.controls.role.setValue('DO');
        this.userForm.controls.role.disable();
      }
    }
    // this.roles = this.roles.sort((a, b) => {
    //   return a.value == b.value ? 0 : a.value > b.value ? 1 : -1;
    // })

    this.areas = [
      {
        id: 'N',
        value: 'Nuvola'
      },
      {
        id: 'P',
        value: 'Project'
      },
      {
        id: 'A',
        value: 'Administration'
      },
      {
        id: 'D',
        value: 'Production'
      }
    ];

    await this.enableDisableFieldsBasedOnRole();

    this.cd.detectChanges();
  }

  async enableDisableFieldsBasedOnRole() {
    if (this.currentLoggedUser.role === 'SA' || this.currentLoggedUser.role === 'DI') {
      // logged-in SUPER AGENT or DISTRIBUTOR
      this.userForm.controls['lastName'].disable();
      this.userForm.controls['firstName'].disable();
      this.userForm.controls['language'].disable();
      this.userForm.controls['idUser'].disable();
      this.userForm.controls['question1'].disable();
      this.userForm.controls['question11'].disable();
      this.userForm.controls['idSuperAgent'].disable();
      this.userForm.controls['idDistributor'].disable();
      return;
    }
    if (this.currentLoggedUser && this.currentLoggedUser.role === 'EX' && this.selectedRow && this.selectedRow.role === 'DO') {
      this.userForm.controls['lastName'].disable();
      this.userForm.controls['firstName'].disable();
      this.userForm.controls['email'].disable();
      this.userForm.controls['active'].disable();
      this.userForm.controls['vat'].disable();
      this.userForm.controls['language'].disable();
      this.userForm.controls['idAgent'].disable();
      this.userForm.controls['question1'].disable();
      this.userForm.controls['question11'].disable();
      this.userForm.controls['idSuperAgent'].disable();
      this.userForm.controls['idDistributor'].disable();
    }
  }

  keyPressNumbers(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (((charCode < 48 || charCode > 57) && charCode !== 43)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  chooseCountry(event) {
    const result = this.allCountries.filter(x => x.iso2 === event);
    if (result.length > 0) {
      this.userForm.controls.whatsappDialCode.setValue('+' + result[0].dialCode);
    }
  }

  clearWhatsappSelection(event) {
    if (!event.checked) {
      this.userForm.controls.whatsappCountryCode.setValue('');
      this.userForm.controls.whatsappDialCode.setValue('');
      this.userForm.controls.whatsappNumber.setValue('');
      // set validation => NO VALIDATION
      this.userForm.controls.whatsappCountryCode.clearValidators();
      this.userForm.controls.whatsappNumber.clearValidators();
    } else {
      // set validation => country code + number are mandatory
      this.userForm.controls.whatsappCountryCode.setValidators([Validators.required]);
      this.userForm.controls.whatsappNumber.setValidators([Validators.required]);
    }
    this.userForm.controls.whatsappCountryCode.updateValueAndValidity();
    this.userForm.controls.whatsappNumber.updateValueAndValidity();
  }

  private async formInit(object?: User) {
    console.log(object);
    this.isEditLoading = true;
    this.userForm = this._fb.group({
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
      password: [null, [
        Validators.minLength(8),
        Validators.maxLength(16),
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$.!%*?&]{8,16}$/)
      ]],
      role: [null, [Validators.required, customNullValidator]],
      active: [false],
      alfacodFlag: [false],
      executiveArea: [''],
      arcadDoctorId: [''],
      idSuperAgent: ['0'],
      idDistributor: ['0'],
      idUser: ['0'],
      userGroup: [''],
      idAgent: ['0'],
      language: [null, [Validators.required, customNullValidator]],
      vat: [null],
      idAdmin: [object ? object.idAdmin : 0],
      idExecutive: [''],
      question1: ['B'],
      question11: [''],
      // question2: ['B'],
      // question3: ['B'],
      privacyFlag: [false, Validators.required],
      cookieFlag: [false, Validators.required],
      temrsFlag: [false, Validators.required],
      whatsappFlag: [false],
      arcadFlag: [false],
      bandoFlag: [false],
      isAssignedProject: [{value: false, disabled: !this.allowEditAssignedProject}],
      forceRefinement: [{value: false, disabled: !this.allowEditForceRefinement}],
      nuvolaBright: [false],
      rigidTemplates: [false],
      aligners24: [false],
      nuvolaView: [false],
      whatsappCountryCode: [''],
      whatsappDialCode: [''],
      whatsappNumber: [''],
      showStepsWarning: [false],
      showNuvolaYoung: [false],
      showNuvolaJunior: [false],
      isPriority: [false],
      showNuvolaSprint: [false],
    });

    if (this.isMyProfileClick) {
      this.userForm.controls.email.disable({ onlySelf: true });
    }

    if (this.showActiveDoctorButton) {
      this.userForm.controls.email.disable({ onlySelf: true });
    }

    if (this.isMyProfileClick && this._userService.readUserFromLocalStorage().role == 'DO') {
      this.userForm.controls.idAgent.disable({ onlySelf: true });
      this.userForm.controls.idUser.disable({ onlySelf: true });
    }

    if (this.isMyProfileClick && this._userService.readUserFromLocalStorage().role == 'US') {
      this.userForm.controls.idExecutive.disable({ onlySelf: true });
      this.userForm.controls.userGroup.disable({ onlySelf: true });
    }

    if (this.isMyProfileClick && this._userService.readUserFromLocalStorage().role == 'AG') {
      this.userForm.controls.idSuperAgent.disable({ onlySelf: true });
      this.userForm.controls.idDistributor.disable({ onlySelf: true });
    }

    if (this.isMyProfileClick && this._userService.readUserFromLocalStorage().role == 'DI') {
      this.userForm.controls.idSuperAgent.disable({ onlySelf: true });
    }

    if (this.isDoctorCreating) {
      this.userForm.controls.role.disable({ onlySelf: true });
      this.userForm.controls.role.clearValidators();
      this.userForm.controls.role.setValue('DO');
      this.onRoleChange();
    }

    if (object) {
      this.userForm.controls.firstName.setValue(object.firstName);
      this.userForm.controls.lastName.setValue(object.lastName);
      this.userForm.controls.email.setValue(object.email);
      this.userForm.controls.role.disable({ onlySelf: true });
      this.userForm.controls.role.setValue(object.role);
      this.userForm.controls.active.setValue(object.active);
      this.userForm.controls.alfacodFlag.setValue(object.alfacodFlag);
      this.userForm.controls.isAssignedProject.setValue(object.isAssignedProject);
      this.userForm.controls.forceRefinement.setValue(object.forceRefinement);
      if (object.role) {
        switch (object.role) {
          case 'EX':
            this.userForm.controls.executiveArea.setValidators([Validators.required, customNullValidator]);
            break;
          case 'AG':
            this.userForm.controls.idSuperAgent.setValidators([Validators.required, customNullValidator]);
            this.userForm.controls.idDistributor.setValidators([Validators.required, customNullValidator]);
            this.superAgents = await this._usersService.getByRole('SA').toPromise() as User[];
            this.distributors = await this._usersService.getByRole('DI').toPromise() as User[];

            // WHATSAPP INFO
            this.userForm.controls.whatsappFlag.setValue(object.whatsAppFlag);
            this.userForm.controls.whatsappCountryCode.setValue(object.whatsAppCountryCode);
            this.userForm.controls.whatsappDialCode.setValue(object.whatsAppDialCode);
            this.userForm.controls.whatsappNumber.setValue(object.whatsAppNumber);

            break;
          case 'DI':
            this.userForm.controls.idDistributor.setValidators([Validators.required, customNullValidator]);
            this.superAgents = await this._usersService.getByRole('SA').toPromise() as User[];
            this.userForm.controls.bandoFlag.setValue(object.bandoFlag);
            break;
          case 'DO':
            this.userForm.addControl('addresses', new FormArray([]));
            this.userForm.controls.vat.setValidators([Validators.maxLength(20)]);
            this.userForm.controls.vat.setValue(object.vat);
            this.agents = await this._usersService.getByRole('AG').toPromise() as User[];
            this.users = await this._usersService.getExecutiveProjectUsers().toPromise() as User[];
            this.userForm.controls.question1.setValue(object.question1);
            this.userForm.controls.question11.setValue(object.question11);
            // this.userForm.controls.question2.setValue(object.question2);
            // this.userForm.controls.question3.setValue(object.question3);
            this.userForm.controls.arcadFlag.setValue(object.arcadFlag);
            this.userForm.controls.arcadDoctorId.setValue(object.arcadDoctorId);
            if (object.clinicPreferences) {
              this.userForm.controls.nuvolaBright.setValue(object.clinicPreferences.nuvolaBright);
              this.userForm.controls.rigidTemplates.setValue(object.clinicPreferences.rigidTemplates);
              this.userForm.controls.aligners24.setValue(object.clinicPreferences.aligners24);
              this.userForm.controls.nuvolaView.setValue(object.clinicPreferences.nuvolaView);
            }
            this.showHowManyPatients = (object.question1 == 'Y');
            if (this.showHowManyPatients) {
              this.userForm.controls.question11.setValidators([Validators.required]);
            }
            // policies
            this.userForm.controls.privacyFlag.setValue(object.policyConfirmed);
            this.userForm.controls.cookieFlag.setValue(object.policyConfirmed);
            this.userForm.controls.temrsFlag.setValue(object.policyConfirmed);
            if (object.policyConfirmed) {
              this.userForm.controls.privacyFlag.disable({ onlySelf: true });
              this.userForm.controls.cookieFlag.disable({ onlySelf: true });
              this.userForm.controls.temrsFlag.disable({ onlySelf: true });
            }
            this.policyConfirmedDate = object.policyConfirmedDate;
            this.whatsappPhoneNumber = object.whatsAppDialCode + object.whatsAppNumber;

            // WHATSAPP INFO
            this.userForm.controls.whatsappFlag.setValue(object.whatsAppFlag);
            this.userForm.controls.whatsappCountryCode.setValue(object.whatsAppCountryCode);
            this.userForm.controls.whatsappDialCode.setValue(object.whatsAppDialCode);
            this.userForm.controls.whatsappNumber.setValue(object.whatsAppNumber);
            // STEPS NOTIFICATIONS
            this.userForm.controls.showStepsWarning.setValue(object.showStepsWarning);
            // NUVOLA JUNIOR
            this.userForm.controls.showNuvolaJunior.setValue(object.showNuvolaJunior);
            this.userForm.controls.isPriority.setValue(object.isPriority);
            this.userForm.controls.showNuvolaSprint.setValue(object.showNuvolaSprint);
            this.userForm.controls.showNuvolaYoung.setValue(object.showNuvolaYoung);
            break;
          case 'US':
            this.groups = await this._usersService.getOptions('UG').toPromise() as any[];
            this.userForm.controls.userGroup.setValue(object.userGroup);
            this.userForm.controls.idExecutive.setValue(`${object.idExecutive}`);
            this.userForm.controls.idExecutive.setValidators([Validators.required, customNullValidator]);

            // STEPS NOTIFICATIONS
            if (object.executiveArea == 'A') {
              this.userForm.controls.showNuvolaJunior.setValue(object.showNuvolaJunior);
              this.userForm.controls.isPriority.setValue(object.isPriority);
              this.userForm.controls.showNuvolaSprint.setValue(object.showNuvolaSprint);
              this.userForm.controls.showNuvolaYoung.setValue(object.showNuvolaYoung);
            }
            break;
        }
        this.onRoleChange();
      }
      this.userForm.controls.executiveArea.setValue(object.executiveArea);
      this.userForm.controls.language.setValue(object.language);
      this.userForm.controls.idSuperAgent.setValue(`${object.idSuperAgent}`);
      this.userForm.controls.idDistributor.setValue(`${object.idDistributor}`);
      this.userForm.controls.idAgent.setValue(`${object.idAgent}`);
      this.userForm.controls.idUser.setValue(`${object.idUser}`);
      this.userForm.controls.vat.setValue(object.vat);
      this.addresses = object.addresses;
      if (!this.addresses) {
        this.addresses = [];
      }
      this.addresses = this.addresses.filter(x => !x.deleted);
    }
    this.isEditLoading = false;

    this.cd.detectChanges();
  }

  allowEditAssignedProject() {
    return this.currentUser.userGroup === 'ED' || this.currentUser.role === 'EX' && this.currentUser.executiveArea === 'P';
  }

  allowEditForceRefinement() {
    return (this.currentUser.userGroup === 'ED' || this.currentUser.userGroup === 'AD') ||
      this.currentUser.role === 'EX' && this.currentUser.executiveArea === 'P';
  }

  onRoleChange() {

    this.superAgents = null;
    this.distributors = null;
    this.userForm.controls.executiveArea.clearValidators();
    this.userForm.controls.executiveArea.setValue('');
    this.userForm.controls.idSuperAgent.clearValidators();
    this.userForm.controls.idSuperAgent.setValue('');
    this.userForm.controls.idDistributor.clearValidators();
    this.userForm.controls.idDistributor.setValue('');
    this.userForm.controls.vat.clearValidators();
    this.userForm.controls.vat.setValue('');
    //
    // this.userForm.controls.question11.clearValidators();
    // this.userForm.controls.question11.setValue('');

    if (this.userForm.controls.role.value == 'EX') {
      this.userForm.controls.executiveArea.setValidators([Validators.required, customNullValidator]);
      this.userForm.controls.executiveArea.markAsTouched({ onlySelf: true });
      return;
    }

    if (this.userForm.controls.role.value == 'DI') {
      this.isEditLoading = true;
      this.userForm.controls.idSuperAgent.setValidators([Validators.required, customNullValidator]);
      this.userForm.controls.idSuperAgent.markAsTouched({ onlySelf: true });
      this._usersService.getByRole('SA').subscribe((resp: User[]) => {
        this.superAgents = resp;
        this.isEditLoading = false;
        this.cd.detectChanges();
      });
      return;
    }

    if (this.userForm.controls.role.value == 'AG') {
      this.isEditLoading = true;
      this.userForm.controls.idSuperAgent.setValidators([Validators.required, customNullValidator]);
      this.userForm.controls.idSuperAgent.markAsTouched({ onlySelf: true });
      this.userForm.controls.idDistributor.setValidators([Validators.required, customNullValidator]);
      this.userForm.controls.idDistributor.markAsTouched({ onlySelf: true });
      this._usersService.getByRole('SA').subscribe((resp: User[]) => {
        this.superAgents = resp;
        this._usersService.getByRole('DI').subscribe((resp: User[]) => {
          this.distributors = resp;
          this.isEditLoading = false;
          this.cd.detectChanges();
        });
      });

      return;
    }

    if (this.userForm.controls.role.value == 'DO') {
      this.isEditLoading = true;
      this._usersService.getByRole('AG').subscribe((resp: User[]) => {
        this.agents = resp;
        this.isEditLoading = false;
        this.cd.detectChanges();
      });
      this._usersService.getExecutiveProjectUsers().subscribe((resp: User[]) => {
        this.users = resp;
        this.isEditLoading = false;
        this.cd.detectChanges();
      });

      this.userForm.addControl('addresses', new FormArray([]));
      this.userForm.controls.vat.setValidators([Validators.maxLength(20)]);

      this.userForm.controls.question1.setValidators([Validators.required]);
      // this.userForm.controls.question2.setValidators([Validators.required]);
      // this.userForm.controls.question3.setValidators([Validators.required]);

      return;
    }

    if (this.userForm.controls.role.value == 'US') {
      this.isEditLoading = true;
      this._usersService.getByRole('EX').subscribe((resp: User[]) => {
        this.executives = resp;
        this.isEditLoading = false;
        this.cd.detectChanges();
      });
      this._usersService.getOptions('UG').subscribe((resp: any[]) => {
        this.groups = resp;
        this.isEditLoading = false;
        this.cd.detectChanges();
      });
      this.userForm.controls.idExecutive.setValidators([Validators.required, customNullValidator]);
    }

  }

  addressSaveHandle(addresses) {
    this.addresses = addresses;
    // console.log(this.addresses);
  }

  allowCreateUpdateDelete() {
    return this.currentLoggedUser && (
      this.currentLoggedUser.role === 'DO' ||
      this.currentLoggedUser.role === 'SA' ||
      this.currentLoggedUser.role === 'EX' ||
      this.currentLoggedUser.role === 'US' && this.currentLoggedUser.userGroup === 'ED' ||
      this.currentLoggedUser.role === 'US' && this.currentLoggedUser.userGroup === 'AD' ||
      this.currentLoggedUser.role === 'US' && this.currentLoggedUser.userGroup === 'SH' ||
      this.currentLoggedUser.role === 'US' && this.currentLoggedUser.userGroup === 'CU'
    );
  }

  allowViewAddresses() {
    return this.currentLoggedUser && (
      this.currentLoggedUser.role === 'DI' ||
      this.currentLoggedUser.role === 'DO' ||
      this.currentLoggedUser.role === 'AG' ||
      this.currentLoggedUser.role === 'EX' ||
      this.currentLoggedUser.role === 'SA' ||
      this.currentLoggedUser.role === 'US' && (
        this.currentLoggedUser.userGroup !== 'ED' ||
        this.currentLoggedUser.userGroup !== 'AD' ||
        this.currentLoggedUser.userGroup !== 'CU'
      )
    );
  }

  save() {
    const prevValue = this.userForm.controls.active.value;
    this.userForm.controls.active.setValue(true);
    if (!this.userForm.valid) {
      this.userForm.controls.active.setValue(prevValue);
      this.userForm.markAllAsTouched();

      this.snackBar.open(this._translocoService.translate('COMMON.errorMessageMandatory'), 'X', {
        duration: 3000,
        panelClass: 'warning',
        horizontalPosition: 'right',
        verticalPosition: 'top',
      } as MatSnackBarConfig);

      return;
    }
    this.userForm.controls.active.setValue(prevValue);

    this.isEditLoading = true;

    const request = {
      ...this.userForm.value,
      addresses: this.addresses.length > 0
        ? this.addresses
        : []
    };

    if (request.addresses) {
      request.addresses.forEach(x => {
        delete (x['iterator']);
      });
    }

    if (this.selectedRow) {
      request.role = this.selectedRow.role;
    }

    if (this.isDoctorCreating) {
      request.role = 'DO';
    }

    if (!this.selectedRow && !this.isDoctorCreating) {
      request.role = this.userForm.controls.role.value;
    }

    if ((request.role === 'DO' && !this.isMyProfileClick)) {
      request.clinicPreferences = {
        nuvolaBright: this.userForm.controls.nuvolaBright.value,
        rigidTemplates: this.userForm.controls.rigidTemplates.value,
        aligners24: this.userForm.controls.aligners24.value,
        nuvolaView: this.userForm.controls.nuvolaView.value,
      };
      delete request.nuvolaBright;
      delete request.rigidTemplates;
      delete request.aligners24;
      delete request.nuvolaView;
    }

    if (request.idSuperAgent == undefined || request.idSuperAgent == '') {
      request.idSuperAgent = 0;
    } else {
      request.idSuperAgent = +request.idSuperAgent;
    }

    if (request.idDistributor == undefined || request.idDistributor == '') {
      request.idDistributor = 0;
    } else {
      request.idDistributor = +request.idDistributor;
    }

    if (request.idAgent == undefined || request.idAgent == '') {
      request.idAgent = 0;
    } else {
      request.idAgent = +request.idAgent;
    }

    if (request.idUser == undefined || request.idUser == '') {
      request.idUser = 0;
    } else {
      request.idUser = +request.idUser;
    }

    if (request.idExecutive == undefined || request.idExecutive == '') {
      request.idExecutive = 0;
    } else {
      request.idExecutive = +request.idExecutive;
    }

    this._usersService.createUser(request).subscribe(resp => {
      this.snackBar.open(this._translocoService.translate('users.createSuccessMessage'), 'X', {
        duration: 3000,
        panelClass: 'success',
        horizontalPosition: 'right',
        verticalPosition: 'top',
      } as MatSnackBarConfig);
      this.isEditLoading = false;
      this.createUpdate.emit(true);
    }, error => {
      this.isEditLoading = false;
      this.cd.detectChanges();
      this.snackBar.open(error.error, 'X', {
        duration: 3000,
        panelClass: 'warning',
        horizontalPosition: 'right',
        verticalPosition: 'top',
      } as MatSnackBarConfig);
    });

  }

  showSaveButton() {
    const allowedRoles = ['AG', 'DI'];
    return this.selectedRow && !this.isDoctorToApprove &&
      (
        this.currentLoggedUser &&
        (!allowedRoles.includes(this.currentLoggedUser.role) && !this.isMyProfileClick) ||
        this.isMyProfileClick
      );
  }

  update() {
    const prevValue = this.userForm.controls.active.value;
    this.userForm.controls.active.setValue(true);
    if (!this.userForm.valid) {
      this.userForm.controls.active.setValue(prevValue);
      this.userForm.markAllAsTouched();

      this.snackBar.open(this._translocoService.translate('COMMON.errorMessageMandatory'), 'X', {
        duration: 3000,
        panelClass: 'warning',
        horizontalPosition: 'right',
        verticalPosition: 'top',
      } as MatSnackBarConfig);

      return;
    }
    this.userForm.controls.active.setValue(prevValue);

    this.isEditLoading = true;

    // console.log('this.userForm.value', this.userForm.value);
    // console.log('this.userForm.value', this.userForm.getRawValue());

    const request = {
      // ...this.userForm.value,
      ...this.userForm.getRawValue(),
      addresses: this.addresses.length > 0
        ? this.addresses
        : [],
      password: 'password'
    };

    if (request.addresses) {
      request.addresses.forEach(x => {
        delete (x['iterator']);
      });
    }

    if (this.selectedRow) {
      request.role = this.selectedRow.role;
    }

    // Fix to handle the my profile modal for doctor
    if (request.role == 'DO') {
      request.active = true;
      request.idSuperAgent = 0;
      request.email = this.userForm.controls.email.value;
      request.idUser = this.userForm.controls.idUser.value;
      request.idAgent = this.userForm.controls.idAgent.value;
      request.policyConfirmed = this.userForm.controls.privacyFlag.value;
      request.showStepsWarning = this.userForm.controls.showStepsWarning.value;
    }
    if (request.role == 'DO' || request.role == 'AG') {
      request.whatsappFlag = this.userForm.controls.whatsappFlag.value;
      request.whatsappCountryCode = this.userForm.controls.whatsappCountryCode.value;
      request.whatsappDialCode = this.userForm.controls.whatsappDialCode.value;
      request.whatsappNumber = this.userForm.controls.whatsappNumber.value;
    } else if (request.role == 'AD' || request.role == 'EX') {
      // add active and email fields for all other roles
      request.active = this.userForm.controls.active.value;
      request.email = this.userForm.controls.email.value;
    } else if (request.role != 'AD' && request.role != 'EX' && request.role != 'DO') {
      // add active and email fields for all other roles
      request.active = true;
      request.email = this.userForm.controls.email.value;
    }

    if (request.idSuperAgent == undefined || request.idSuperAgent == '') {
      request.idSuperAgent = 0;
    }

    if (request.idDistributor == undefined || request.idDistributor == '') {
      request.idDistributor = 0;
    }

    if (request.idAgent == undefined || request.idAgent == '') {
      request.idAgent = 0;
    } else {
      request.idAgent = +request.idAgent;
    }

    if (request.idUser == undefined || request.idUser == '') {
      request.idUser = 0;
    } else {
      request.idUser = +request.idUser;
    }

    if (request.idExecutive == undefined || request.idExecutive == '') {
      request.idExecutive = 0;
    } else {
      request.idExecutive = +request.idExecutive;
    }

    if ((request.role === 'DO' && !this.isMyProfileClick) || (this.currentLoggedUser.role === 'DO' && this.isMyProfileClick)) {
      request.clinicPreferences = {
        nuvolaBright: this.userForm.controls.nuvolaBright.value,
        rigidTemplates: this.userForm.controls.rigidTemplates.value,
        aligners24: this.userForm.controls.aligners24.value,
        nuvolaView: this.userForm.controls.nuvolaView.value,
      };
      delete request.nuvolaBright;
      delete request.rigidTemplates;
      delete request.aligners24;
      delete request.nuvolaView;
    }

    request.idDistributor = +request.idDistributor;
    request.idSuperAgent = +request.idSuperAgent;

    const nuvolaUser = JSON.parse(localStorage.getItem('nuvolaUser'));

    console.log('request', request);

    this._usersService.updateUser(request).subscribe((resp: any) => {

      if (request.idAdmin == nuvolaUser.idAdmin) {
        nuvolaUser.profileComplete = resp.profileComplete;
        this.profileComplete = resp.profileComplete;
        nuvolaUser.showStepsWarning = resp.showStepsWarning;
        localStorage.setItem('nuvolaUser', JSON.stringify(nuvolaUser));
      }

      this.snackBar.open(this._translocoService.translate('users.updateSuccessMessage'), 'X', {
        duration: 3000,
        panelClass: 'success',
        horizontalPosition: 'right',
        verticalPosition: 'top',
      } as MatSnackBarConfig);
      this.isEditLoading = false;

      if (this.profileComplete) {
        this.userForm.reset();
      }
      this.createUpdate.emit(true);
    }, error => {
      let errorMsg = this._translocoService.translate('users.errorMessage');
      if (error.status == 501) {
        errorMsg = this._translocoService.translate('users.errorMessageEmailInUse');
      }
      this.snackBar.open(errorMsg, 'X', {
        duration: 3000,
        panelClass: 'warning',
        horizontalPosition: 'right',
        verticalPosition: 'top',
      } as MatSnackBarConfig);
      this.isEditLoading = false;
      // this.userForm.reset();
      this.formInit(this.selectedRow);
    });
    // this.selectedRow = null;
  }

  onZipCodeInput(event) {
    const currentValue = this.userForm.controls.zipCode.value;
    this.userForm.controls.zipCode.reset();
    this.userForm.controls.zipCode.setValue(currentValue.replace(/[^0-9.]/g, ''));
  }

  closeModal() {
    this.createUpdate.emit(false);
    this.location.back();
  }

  openResetModalConfirm(tempalteRef) {
    this.resetPasswordModal = this.modalServide.open(tempalteRef, { closeOnNavigation: true });
  }

  openSendEmailModal(tempalteRef) {
    this.sendEmailModal = this.modalServide.open(tempalteRef, { closeOnNavigation: true });
  }

  closeResetModal() {
    this.resetPasswordModal.close();
  }

  closeSendEmailModal() {
    this.sendEmailModal.close();
  }

  reset() {
    this._authService.forgorPassword(this.selectedRow.email).subscribe(resp => {
      if (resp) {
        this.snackBar.open(this._translocoService.translate('users.resetSuccessMessage'), 'X', {
          direction: 'rtl',
          duration: 3000,
          panelClass: 'success',
          horizontalPosition: 'right',
          verticalPosition: 'top',
        } as MatSnackBarConfig);
      }
      this.closeResetModal();
      this.closeModal();
    }, error => {
      this.snackBar.open(this._translocoService.translate('users.errorMessage'), 'X', {
        direction: 'rtl',
        duration: 3000,
        panelClass: 'warning',
        horizontalPosition: 'right',
        verticalPosition: 'top',
      } as MatSnackBarConfig);
    });
  }

  sendConfirmEmailToDoctor() {
    this.isEditLoading = true;
    this._authService.sendConfirmEmailToDoctor(this.selectedRow.idAdmin).subscribe(resp => {
      if (resp) {
        this.snackBar.open(this._translocoService.translate('users.activeDoctorSuccessMessage'), 'X', {
          duration: 3000,
          panelClass: 'success',
          horizontalPosition: 'right',
          verticalPosition: 'top',
        } as MatSnackBarConfig);
      }
      this.isEditLoading = false;
      this.closeSendEmailModal();
      this.cd.detectChanges();
    }, error => {
      this.snackBar.open(this._translocoService.translate('users.errorMessage'), 'X', {
        duration: 3000,
        panelClass: 'warning',
        horizontalPosition: 'right',
        verticalPosition: 'top',
      } as MatSnackBarConfig);
      this.isEditLoading = false;
      this.cd.detectChanges();
    });
  }

  getCurrentGroupTittle(group) {
    switch (this._translocoService.getActiveLang()) {
      case 'en':
        return group.optionTitle_EN;
      case 'it':
        return group.optionTitle_IT;
    }
  }

  toggleAligners(event: any) {
    if (event.value == 'Y') {
      this.showHowManyPatients = true;
      this.userForm.controls.question11.setValidators(Validators.required);
    } else {
      this.showHowManyPatients = false;
      this.userForm.controls.question11.clearValidators();
    }
  }

  disableClinicPreferences() {
    return (this.currentLoggedUser.role === 'AG' || this.currentLoggedUser.role === 'DI') ||
      (this.currentLoggedUser.role === 'DO' && this.isMyProfileClick) ||
      (this.currentLoggedUser.role === 'SA' && !this.isMyProfileClick) ||
      (this.currentLoggedUser && this.currentLoggedUser.role === 'EX' && this.selectedRow && this.selectedRow.role === 'DO');
  }

  hideRigid() {
    return this.currentLoggedUser && this.currentLoggedUser.role === 'DO' && this.isMyProfileClick ||
      (this.currentLoggedUser.role === 'AG' || this.currentLoggedUser.role === 'DI');
  }

  hideAligners() {
    return (this.currentLoggedUser.role === 'DO' && this.isMyProfileClick) ||
      (
        (this.currentLoggedUser.role === 'AG' ||
        this.currentLoggedUser.role === 'DI' ||
        this.currentLoggedUser.role === 'SA'
        ) &&
        !this.isMyProfileClick
      );
  }

}

export function customNullValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    return control.value == 'null' ? { value: control.value } : null;
  };
}
